(function(){
  function ready(fn){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn):fn();}
  ready(function(){
    var header=document.querySelector('.pckey-v66-header[data-eq-header], .pckey-v66-header');
    if(!header) return;
    function setHeaderHeight(){
      var h=Math.ceil(header.getBoundingClientRect().height||0);
      if(h>40) document.documentElement.style.setProperty('--pckey-header-h', h+'px');
    }
    setHeaderHeight(); window.addEventListener('resize',setHeaderHeight,{passive:true}); setTimeout(setHeaderHeight,350);

    var toggle=header.querySelector('[data-menu-toggle]');
    var nav=header.querySelector('[data-mobile-nav]');
    function closeMenu(){
      header.classList.remove('is-menu-open');
      if(toggle) toggle.setAttribute('aria-expanded','false');
      header.querySelectorAll('[data-dropdown].is-open').forEach(function(el){el.classList.remove('is-open'); var b=el.querySelector('[data-dropdown-toggle]'); if(b)b.setAttribute('aria-expanded','false');});
    }
    if(toggle){
      toggle.addEventListener('click',function(e){
        e.preventDefault();
        var open=!header.classList.contains('is-menu-open');
        header.classList.toggle('is-menu-open',open);
        toggle.setAttribute('aria-expanded',open?'true':'false');
        setHeaderHeight();
      });
    }
    header.querySelectorAll('[data-dropdown-toggle]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        if(window.matchMedia('(max-width: 989px)').matches){
          e.preventDefault();
          var item=btn.closest('[data-dropdown]');
          var open=item && !item.classList.contains('is-open');
          header.querySelectorAll('[data-dropdown].is-open').forEach(function(el){if(el!==item){el.classList.remove('is-open'); var b=el.querySelector('[data-dropdown-toggle]'); if(b)b.setAttribute('aria-expanded','false');}});
          if(item){item.classList.toggle('is-open',open); btn.setAttribute('aria-expanded',open?'true':'false');}
        }
      });
    });
    if(nav){nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',closeMenu);});}
    document.addEventListener('keydown',function(e){if(e.key==='Escape') closeMenu();});
    document.addEventListener('click',function(e){if(!header.contains(e.target) && window.matchMedia('(max-width: 989px)').matches) closeMenu();});
  });
})();
